import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when some component fires 'backButton:show'.
 * @memberOf Playtech.API.events
 * @event header:backButton:toggle
 * @type {callback}
 * @example Playtech.on('header:backButton:toggle', () => { ... });
 */
export const EVENT_BACK_BUTTON_TOGGLE = 'header:backButton:toggle';

export const useOnBackButtonToggle = (eventTarget) => {
    const handleEvent = useCallback(() => {
        const event = new CustomEvent(EVENT_BACK_BUTTON_TOGGLE);

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on(EVENT_BACK_BUTTON_TOGGLE, handleEvent);

        return () => {
            publicEventsAPIService.off(EVENT_BACK_BUTTON_TOGGLE, handleEvent);
        };
    }, [handleEvent]);
};
